import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid2x0x0 = (): GridInterface[] =>
  defineGrid(
    '2:0:0',
    [
      {
        name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
        breakpoint: BREAKPOINT_VALUE.SITEBAR,
        rows: [
          {
            columns: [
              {
                tileId: 0,
                spanRow: 3,
              },
              {
                tileId: 1,
                spanRow: 3,
              },
            ],
          },
        ],
      },
      {
        name: 'HPA 1/2',
        breakpoint: BREAKPOINT_VALUE.HPA,
        rows: [
          {
            columns: [
              {
                tileId: 0,
                spanRow: 3,
              },
            ],
          },
        ],
      },
      {
        name: 'HPA 2/2',
        breakpoint: BREAKPOINT_VALUE.HPA,
        rows: [
          {
            columns: [
              {
                tileId: 1,
                spanRow: 3,
              },
            ],
          },
        ],
      },
      {
        name: 'Mobile 1/2',
        breakpoint: BREAKPOINT_VALUE.MOBILE,
        rows: [
          {
            columns: [
              {
                tileId: 0,
                spanRow: 2,
              },
            ],
          },
        ],
      },
      {
        name: 'Mobile 2/2',
        breakpoint: BREAKPOINT_VALUE.MOBILE,
        rows: [
          {
            columns: [
              {
                tileId: 1,
                spanRow: 2,
              },
            ],
          },
        ],
      },
    ],
    3,
    3,
  );
